import { Col, Container, Row } from "react-bootstrap";

import React from "react";
import { TableAsesor } from "../../DataTables/Asesor/TableAsesor";

const DashboardAsesores = ({ isTabActive }) => {
  return (
    isTabActive && (
      <Container fluid>
        <Row className="mt-3">
          <Col>
            <TableAsesor />
          </Col>
        </Row>
      </Container>
    )
  );
};

export default DashboardAsesores;
